<template>
  <span v-if="isLoading" class="status-wrapper status-loading">
    <Icon type="ios-loading" class="icon-loading" size="14" />
    <span class="status-text">{{ loadingText || $t('common.loading') }}</span>
  </span>
  <span v-else class="status-wrapper">
    <i class="status-dot" :class="type"></i>
    <span v-if="text" class="status-text">{{ text }}</span>
  </span>
</template>

<script>
export default {
  name: 'StatusDot',
  props: {
    type: { type: String, default: '' },
    text: { type: String, default: '' },
    isLoading: { type: Boolean, default: false },
    loadingText: { type: String, default: '' },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/mixins.scss';

.status-wrapper {
  @include display-flex(flex-start);
}

.status-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  background-color: #a8acb6;
}
.status-dot.running {
  background-color: $--primary-color;
}

.status-dot.error {
  background-color: $--danger-color;
}

.status-dot.stoped {
  background-color: #a8acb6;
}

@keyframes status-loading-animation {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.icon-loading {
  animation: status-loading-animation 1s linear infinite;
}

.status-text {
  margin-left: 4px;
}
</style>
